import { IClassname } from '@/lib/shared/model/classname';

export const Security = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8052 28.9709V21.1245"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.722 7.24658C14.3002 7.79664 14.0712 8.47027 14.0703 9.16346C14.0703 10.0108 14.4069 10.8234 15.006 11.4225C15.6052 12.0217 16.4178 12.3582 17.2651 12.3582C18.1124 12.3582 18.925 12.0217 19.5242 11.4225C20.1233 10.8234 20.4599 10.0108 20.4599 9.16346C20.4664 8.47322 20.2464 7.79988 19.8337 7.24658H14.722Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8338 7.24635H14.0832L12.652 3.91099C12.6082 3.80414 12.5942 3.68741 12.6114 3.57324C12.6287 3.45906 12.6766 3.35169 12.75 3.26255C12.8234 3.17341 12.9196 3.10584 13.0283 3.067C13.1371 3.02817 13.2543 3.01953 13.3676 3.04201L20.3067 4.49883C20.4013 4.51979 20.4899 4.562 20.5658 4.62227C20.6418 4.68254 20.703 4.75929 20.7448 4.84671C20.7867 4.93413 20.8081 5.02993 20.8075 5.12685C20.8068 5.22378 20.7842 5.31929 20.7412 5.40615L19.8338 7.24635Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0832 7.24658L11.5273 8.5245"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8051 21.112L9.26528 25.5847C8.974 25.9975 8.53243 26.2796 8.03543 26.3704C7.53843 26.4612 7.02565 26.3534 6.60722 26.0703C6.39832 25.9282 6.2198 25.7459 6.08205 25.5341C5.9443 25.3223 5.85008 25.0852 5.80488 24.8366C5.75969 24.588 5.76441 24.3329 5.81879 24.0862C5.87317 23.8394 5.97611 23.606 6.12161 23.3994L11.8722 15.7319C12.0491 15.4792 12.2843 15.2729 12.558 15.1305C12.8316 14.9881 13.1356 14.9139 13.4441 14.9141H14.952C15.063 14.9172 15.1715 14.948 15.2674 15.0038C15.3634 15.0596 15.4439 15.1386 15.5015 15.2335L17.2778 18.1089L19.003 15.2335C19.0606 15.1386 19.1411 15.0596 19.2371 15.0038C19.3331 14.948 19.4415 14.9172 19.5525 14.9141H20.4726C21.4894 14.9141 22.4645 15.318 23.1835 16.0369C23.9025 16.7559 24.3064 17.731 24.3064 18.7478V25.7764C24.3064 26.2847 24.1044 26.7723 23.7449 27.1318C23.3854 27.4913 22.8979 27.6932 22.3895 27.6932C21.8811 27.6932 21.3935 27.4913 21.0341 27.1318C20.6746 26.7723 20.4726 26.2847 20.4726 25.7764V19.3868"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.696 28.9707H1.30396"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
